var skanGym = skanGym || {};

$(window).load(function () {
	if($('.image-carousel').length){
		skanGym.slider.heroSlider($('.image-carousel'));
	}
	if($('.gallery .owl-carousel').length){
		skanGym.slider.gallerySlider($('.gallery .owl-carousel'));
	}
});

skanGym.slider = new function(){

	this.heroSlider = function(t) {
		if($(".umb-grid").find('section').first().hasClass('image-carousel')){
			$('body').addClass('has-slider');
		}

		var autoplayProp = false;

		if(t.closest('[data-autoplay]').length) {
			var apAttribute = t.closest('[data-autoplay]').attr('data-autoplay').toLowerCase();
			autoplayProp = apAttribute == 'no' ? false : true;
		}

		t.owlCarousel({
			responsive:{
				0:{
					items:1
				}
			},
			autoplay: autoplayProp,
			video:true,
			center:true,
			singleItem:true,
			autoHeight : false,
			lazyLoad:true,
			loop:true,
			nav:false,
			dots: true
		});
	};

	this.gallerySlider = function(t) {
		t.owlCarousel({
			responsive:{
				0:{
					items:2
				},
				480:{
					items:4
				},
				786: {
					items:5
				},
				992: {
					items:6
				}
			},
			loop:true,
			margin:30,
			video:false,
			center:false,
			singleItem:false,
			autoHeight : false,
			lazyLoad:true,
			nav:false,
			dots:false
		});

		// Set custom next/prev click events for "logged in slider"
		$(".custom-next").click(function(e){
			e.preventDefault();
			t.trigger('next.owl.carousel');
		})
		$(".custom-prev").click(function(e){
			e.preventDefault();
			t.trigger('prev.owl.carousel');
		})
	};

};